module.exports = __webpack_public_path__ + "static/media/people.5730b392.svg";